import { render, staticRenderFns } from "./SubscriptionSettings.vue?vue&type=template&id=bf9cc0f6&"
import script from "./SubscriptionSettings.vue?vue&type=script&lang=js&"
export * from "./SubscriptionSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SubscriptionSettings.vue"
export default component.exports